import { ensureError } from '@fabric-app/utils/guards';

const isVTTCue = (cue) => {
  return "startTime" in cue && "endTime" in cue && "text" in cue;
};
const hashCue = (cue) => {
  return {
    startTime: cue.startTime,
    endTime: cue.endTime,
    text: cue.text,
    hash: `${cue.startTime}-${cue.endTime}-${cue.text}`
  };
};
const parseVTT = async (vttUrl) => {
  try {
    const response = await fetch(vttUrl);
    if (!response.ok) {
      throw new Error(`Failed to load VTT file: ${response.statusText}`);
    }
    const vttBlob = new Blob([
      await response.text()
    ], {
      type: "text/vtt"
    });
    const blobUrl = URL.createObjectURL(vttBlob);
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const track = document.createElement("track");
      track.kind = "subtitles";
      track.src = blobUrl;
      track.default = true;
      video.appendChild(track);
      track.addEventListener("load", () => {
        const cues = Array.from(track.track.cues || []).filter(isVTTCue);
        resolve(cues.map(hashCue));
        video.remove();
        URL.revokeObjectURL(blobUrl);
      });
      track.addEventListener("error", (error) => {
        URL.revokeObjectURL(blobUrl);
        reject(new Error(`Failed to load VTT file: ${error.message}`));
        video.remove();
      });
    });
  } catch (error) {
    throw new Error(`Failed to load VTT file: ${ensureError(error).message}`);
  }
};

export { parseVTT };
//# sourceMappingURL=parseVTT.js.map
